
import React, { useState, useEffect } from 'react';
import { debugLog } from '@/config/debug';

interface CountdownOverlayProps {
  isVisible: boolean;
  onComplete: () => void;
}

const CountdownOverlay = ({ isVisible, onComplete }: CountdownOverlayProps) => {
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (isVisible) {
      debugLog('TIMER', 'CountdownOverlay: Starting countdown - resetting to 3');
      setCount(3); // Reset count when overlay becomes visible
    }
  }, [isVisible]);

  useEffect(() => {
    if (isVisible && count > 0) {
      debugLog('TIMER', `CountdownOverlay: Count is ${count}, setting timer`);
      const timer = setTimeout(() => {
        debugLog('TIMER', `CountdownOverlay: Timer fired, decreasing count from ${count} to ${count - 1}`);
        setCount(count - 1);
      }, 1000);
      return () => {
        debugLog('TIMER', 'CountdownOverlay: Cleaning up timer');
        clearTimeout(timer);
      };
    } else if (isVisible && count === 0) {
      debugLog('TIMER', 'CountdownOverlay: Count reached 0, calling onComplete');
      onComplete();
    }
  }, [count, isVisible, onComplete]);

  if (!isVisible || count === 0) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: 99999 }}>
      <div className="text-white text-6xl sm:text-9xl font-bold animate-pulse">{count}</div>
    </div>
  );
};

export default CountdownOverlay;
